// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2WBKO","dragIcon":"Choice_dragIcon__3EKof","left":"Choice_left__3yL8E","input":"Choice_input__370Lk"};